import React, { FC, useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable';

import { useStyles } from '@sravni/react-utils';

import { SearchBlock, SearchBlockProps } from '../SearchBlock';

import styles from './top-search.module.scss';

export const TopSearch: FC<Omit<SearchBlockProps, 'topBlock'>> = ({ toggleOverlay, topBlockActive }) => {
  const [maxHeight, setMaxHeight] = useState<0 | '100'>(0);
  const cx = useStyles(styles);

  const { ref } = useSwipeable({
    onSwiping: (eventData) => {
      if (window.scrollY > 100) return;

      if (eventData.dir === 'Down') {
        setMaxHeight('100'); // ставим максимальную высоту больше, чем высота поиска
      } else if (eventData.dir === 'Up') {
        setMaxHeight(0);
        toggleOverlay('off');
      }
    },
  });

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    ref(body);

    return () => ref(null);
  });

  return (
    <div className={cx('topSearch')} style={{ maxHeight: `${maxHeight}px` }}>
      <SearchBlock topBlock={true} topBlockActive={topBlockActive} toggleOverlay={toggleOverlay} />
    </div>
  );
};

TopSearch.displayName = 'TopSearch';
